import React from 'react';
import { Link } from 'react-router-dom'
import Utilities from '../../utils/Utilities';

function Breadcrumbs (props) {
    if (!props.breadcrumbs.length) return <span />;
    var fullRoute = '';

    return (<ol className="breadcrumb hidden-print">
        <li>
            <Link to="/">Dashboard</Link>
        </li>
        {props.breadcrumbs.map(function (crumb, index) {

            fullRoute += '/' + crumb;
            var route = <Link to={fullRoute}>{Utilities.getHumanReadable(crumb)}</Link>, bsClass = '';

            if (index === props.breadcrumbs.length - 1) {
                // route = crumb;
                bsClass = 'active';
            }

            return (
                <li key={'breadcrumb-' + crumb + '-' + index} className={bsClass}>
                    {route}
                </li>
            );
        })}
    </ol>);
}

Breadcrumbs.defaultProps = {
    breadcrumbs: []
};

export default Breadcrumbs;
